export const sameDomain = (urlA, urlB) => {
    const a = document.createElement('a');
    const b = document.createElement('a');
    a.href = urlA;
    b.href = urlB;
    return a.hostname === b.hostname;
};
